const getters = {
  activateVoucher: state => state.activateVoucher,
  authenticationInfo: state => state.authenticationInfo,
  proTitleId: state => state.proTitleId,
  organizationMessage: state => state.organizationMessage,
  tissueMessage: state => state.tissueMessage,
  organizationCheckedInfo: state => state.organizationCheckedInfo,

  menuIndex: state => state.menuIndex,
  organizations: state => state.organizations,
  resources: state => state.resources,
  logoUrl: state => state.logoUrl,
  organizationName: state => state.organizationName,
  itemType: state => state.itemType
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js